export default [
  {
    path: '/label/my-tracks',
    name: 'My Tracks Label',
    title: 'My Tracks',
    component: () =>
      import(/* webpackChunkName: 'my-tracks-label' */ './views/Index.vue')
  },
  {
    path: '/label/my-tracks/overview',
    name: 'Label Track Overview',
    title: 'My Tracks Overview',
    component: () =>
        import(/* webpackChunkName: 'my-tracks-label-overview' */ './views/Overview.vue')
  }
]
